// 只展示 PHP 持久化的来源白名单；旧卡没有来源时不推断为手动任务。
export function projectWorkSourceLabel(payload) {
  const source = payload?.workSource
  if (!source || !['manual', 'automation'].includes(source.kind)) return ''
  const text = (value, fallback) => typeof value === 'string' && value.trim() ? value.trim() : fallback
  const title = text(source.taskTitle, '项目工作')
  const origin = source.kind === 'automation'
    ? `自动化触发 · ${text(source.automationName, '自动化任务')} · ${title}` : `手动交办 · ${title}`
  if (!Number.isSafeInteger(source.triggeredAt) || source.triggeredAt < 1) return `${origin} · 触发时间待确认`
  const date = new Date(source.triggeredAt * 1000)
  if (!Number.isFinite(date.getTime())) return `${origin} · 触发时间待确认`
  let timezone = text(source.timezone, 'UTC'), time
  try {
    time = new Intl.DateTimeFormat('sv-SE', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(date)
  } catch (_) { timezone = 'UTC'; time = date.toISOString().slice(0, 19).replace('T', ' ') }
  return `${origin} · 触发：${time}（${timezone}）`
}
